export const localStorageKeys = {
  authToken: 'authToken',
  isGDPRShowed: 'isGDPRShowed', // show GDPR again,
  allBackendSettings: 'allBackendSettings',
  guestRecentChats: 'travelbuddy_guest_recent_chats', // for anonymous users only
  googlePlaceTypeToPull: 'googlePlaceTypeToPull',
  googlePlaceTypeToPullForAreaBusiness: 'googlePlaceTypeToPullForAreaBusiness',
  googlePlaceTypeToPullForLocalSecrets: 'googlePlaceTypeToPullForLocalSecrets',
};
